import RequestState from 'Enums/RequestState'
import IFFilterType from 'Enums/IFFilterType'

export const INITIAL_STATE = {
  operatorUsers: [],
  tariffsList: [],
  privacySchedule: [],
  accessGroupsList: [],
  inviteOperatorUsers: [],
  inviteOperatorUser: {},
  inviteOperatorUserStatus: '',
  operatorUsersPagination: 0,
  operatorUsersCount: 0,
  operatorUsersInvitationsCount: 0,
  inviteOperatorUsersPagination: 0,
  clickedOperatorUser: {},
  fetchOperatorUserListRequestState: RequestState.UNINITIALIZED,
  fetchTariffListRequestState: RequestState.UNINITIALIZED,
  fetchPrivacyScheduleRequestState: RequestState.UNINITIALIZED,
  fetchAccessGroupsListRequestState: RequestState.UNINITIALIZED,
  updateOperatorUserListRequestState: RequestState.UNINITIALIZED,
  deleteOperatorUserRequestState: RequestState.UNINITIALIZED,
  unblockOperatorUserRequestState: RequestState.UNINITIALIZED,
  fetchInviteOperatorUserListRequestState: RequestState.UNINITIALIZED,
  fetchInviteOperatorUserRequestState: RequestState.UNINITIALIZED,
  inviteOperatorUserRequestState: RequestState.UNINITIALIZED,
  deleteInviteOperatorUserRequestState: RequestState.UNINITIALIZED,
  sendOperatorUserEmailRequestState: RequestState.UNINITIALIZED,
  createOperatorUserRequestState: RequestState.UNINITIALIZED,
  fetchOperatorUsersCountRequestState: RequestState.UNINITIALIZED,
  fetchOperatorUsersInvitationsCountRequestState: RequestState.UNINITIALIZED,
  changePasswordOrNameRequestState: RequestState.UNINITIALIZED,
  updateOperatorUserRequestState: RequestState.UNINITIALIZED,
  operatorUsersFilter: [
    {
      type: IFFilterType.KEYWORD,
      title: null,
      data: null,
      initialValue: [],
      value: [],
    },
    {
      type: IFFilterType.DATE_RANGE,
      title: 'Date',
      initialValue: [],
      value: [],
    },
  ],
  operatorUsersAlertEmails: [],
}
